import { type ComponentProps, type FC, useState } from "react";
import type { Icon } from "../common/Icon";
import { Modal, useModal } from "../common/modal/Modal";
import { Button } from "../components/Button";

type Props = {
	prompt?: string;
	confirmText?: string;
	icon?: ComponentProps<typeof Icon>["name"];
	variant?: ComponentProps<typeof Button>["variant"];
	onConfirm: () => Promise<void>;
};

export const ModalConfirmation: FC<Readonly<Props>> = ({
	onConfirm,
	confirmText,
	prompt,
	icon,
	variant = "danger",
}) => {
	const { close } = useModal();
	const [pending, setPending] = useState(false);

	return (
		<Modal>
			<h2 className="pb-4">
				{prompt ? prompt : "Are you sure you want to proceed"}
			</h2>

			<Button
				full
				icon={icon}
				variant={variant}
				loading={pending}
				disabled={pending}
				onClick={async () => {
					setPending(true);
					try {
						await onConfirm();
						close();
					} finally {
						setPending(false);
					}
				}}
			>
				{confirmText ?? "Confirm"}
			</Button>
		</Modal>
	);
};
